import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import About from '../views/About.vue'
import Home from '../views/Home.vue'
import Login from '../views/common/Login.vue'

import Posts from '../views/content/Posts.vue'
import Drafts from '../views/content/Drafts.vue'
import PostDetails from '../components/content/PostDetails.vue'

import PostTypeReport from "../views/reports/PostTypeReport"
import PostCountReport from "../views/reports/PostCountReport"
import PostVisitorsReport from "../views/reports/PostVisitorsReport"

import Campaigns from "../views/campaigns/Campaigns"
import Banners from "../views/campaigns/Banners"
import GoogleAds from "../views/campaigns/GoogleAds"

import Users from '../views/crm/Users.vue'
import UserDetails from '../components/crm/UserDetails.vue'

import VotingWidgets from '../views/tools/VotingWidgets'
import Settings from "../views/security/Settings"

import ChangePassword from '../components/common/ChangePassword.vue'
import MyAccount from '../components/common/MyAccount.vue'

import Dashboard from '../components/dashboard/Index.vue'


const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/posts',
      name: 'posts',
      component: Posts
    },
    {
      path: '/posts/drafts',
      name: 'drafts',
      component: Drafts
    },
    {
      path: '/posts/:id',
      name: 'postDetails',
      component: PostDetails
    },
    {
      path: '/reports/post-type',
      name: 'postTypeReport',
      component: PostTypeReport
    },
    {
      path: '/reports/post-count',
      name: 'postCount',
      component: PostCountReport
    },
    {
      path: '/reports/post-visitors',
      name: 'postVisitors',
      component: PostVisitorsReport
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      component: Campaigns
    },
    {
      path: '/campaigns/banners',
      name: 'banners',
      component: Banners
    },
    {
      path: '/campaigns/google-ads',
      name: 'googleAds',
      component: GoogleAds
    },
    {
      path: '/tools/voting-widgets',
      name: 'votingWidgets',
      component: VotingWidgets
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/users/:id',
      name: 'userDetails',
      component: UserDetails
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/my-account',
      name: 'my-account',
      component: MyAccount
    },
    {
      path: '/my-account/change-password',
      name: 'change-password',
      component: ChangePassword
    },
  ]
})

router.beforeEach((to, from, next) => {
  //console.log('from', from, 'to', to, 'params: ', to.params);
  //this.$router.go() reload
  next();
})

export default router;
